<app-email-pods [selectedPods]='this.selectedPods'></app-email-pods>
<app-print-pods [selectedPods]='this.selectedPods'></app-print-pods>

<div class="fullcontainer" >

    <br />
    <br />
  
    <div class='titleContainer'>
      <h2 class='header' style='color: #006498'>All Proof Of Delivery</h2>
      <div>
      <button class='btn btn-secondary' (click)='this.email()'><i class="fas fa-envelope"></i> Email PODs</button>&nbsp;
      <button class='btn btn-secondary' (click)='this.batchPrintPODs()'><i class="fas fa-print"></i> Print PODs</button>&nbsp;
    </div>
    </div>
    <br />
    <br /> 
    <app-grid 
  entity='driver-job-movement'
  [checkboxSelector]='true' 
  [filters]='this.filters'
  [columns]='this.columns'
  [buttons]='this.buttons'
  [searchFilters]='this.searchFilters'
  [searchFields]='this.searchFields'
  [relationships]='["vehicle", "driver", "job","job.order"]'
  (recordsUpdate)='this.recordUpdated($event)'
  (checkboxSelected)='this.onCheckedSelected($event)'
  ></app-grid>